var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phases"},[_c('MappedSelectionField',{attrs:{"hasError":_vm.hasError,"disabled":_vm.disabled,"value":_vm.value,"items":_vm.phases},on:{"change":function($event){return _vm.$emit('change', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }